<template>
  <h3>SCIM Authentication</h3>
  <h4>OAuth 2.0 Bearer Tokens</h4>
  <skeleton-cards v-if="loading" :card-count="3" />
  <ul v-else class="scim-tokens">
    <li v-for="token in activeOrRecentlyDeactivatedScimTokens" :key="token.id">
      <scim-bearer-token-card :token="token"/>
    </li>
  </ul>
  <atom-button label="Generate new token"
               :icon="generateButtonIcon"
               type="primary"
               :disabled="!canCreateNewToken"
               @click="generateNewToken"/>
  <scim-new-token-modal v-if="newToken" :new-token="newToken" @modal-closed="emptyNewToken" />
</template>

<script lang="ts">
import ScimBearerTokenCard from "authentication/components/scim/ScimBearerTokenCard.vue";
import ScimNewTokenModal from "authentication/components/scim/ScimNewTokenModal.vue";
import { useScimStore } from "authentication/stores/scim-tokens.store";
import AtomButton from "core/components/atom/button/AtomButton.vue";
import SkeletonCards from "core/components/skeletons/generic/SkeletonCards.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    ScimNewTokenModal,
    SkeletonCards,
    AtomButton,
    ScimBearerTokenCard,
  },
  setup() {
    return {
      scimStore: useScimStore(),
    };
  },
  data() {
    return {
      newToken: "",
      generatingToken: false,
      loading: true,
    };
  },
  computed: {
    activeOrRecentlyDeactivatedScimTokens() {
      return this.scimStore.scimTokens;
    },
    canCreateNewToken(): boolean {
      return this.scimStore.canCreateNewToken && !this.generatingToken && !this.loading;
    },
    generateButtonIcon() {
      return this.generatingToken ? "animated-spinner" : undefined;
    },
  },
  async created() {
    try {
      await this.scimStore.isReady();
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async generateNewToken() {
      this.generatingToken = true;
      this.loading = true;
      try {
        const newToken = await this.scimStore.generateScimToken();
        this.newToken = newToken.rawToken;
      } finally {
        this.generatingToken = false;
        this.loading = false;
      }
    },
    emptyNewToken() {
      this.newToken = "";
    },
  },
});
</script>

<style scoped lang="scss">
.scim-tokens {
  list-style-type: none;
  padding-left: 0;
}
.content-actions {
  border: none;
}
</style>
